<template>
  <b-modal
    no-close-on-backdrop
    title="ALTERAR PERFIL DE USUÁRIO"
    id="view_user_profile"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit" method="post">
      <div class="row">
        <div class="col-md-12">
          <label-required-field label="Nome" />
          <input
            type="text"
            ref="autofocus"
            v-model="name"
            class="form-control"
          />
          <warning-required-fields />
          <errors-messages :errors="errors" />
        </div>
        <div class="col-md-12 text-right">
          <v-btn
            @click="evOnBtnRemoveClick"
            :disabled="loading"
            class="btn-delete ml-2"
          >
            <i class="fas fa-trash mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "REMOVER" }}
          </v-btn>
          <v-btn type="submit" :disabled="loading" class="btn-save ml-2">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "ViewUserProfile",

  components: { ErrorsMessages, LabelRequiredField, WarningRequiredFields },

  props: {
    user_profile: { required: true },
  },

  data() {
    return {
      errors: [],
      loading: false,

      name: "",
    };
  },

  watch: {
    user_profile(value) {
      if (!value) return;

      this.$bvModal.show("view_user_profile");
    },
  },

  methods: {
    async evOnShow() {
      this.name = this.user_profile.name;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let { user_profile, name } = this;

        if (String(name).toUpperCase() == "MASTER") {
          this.errors = ["Informe outro nome"];
          this.loading = false;
          return;
        }

        const data = { id: user_profile.id, name };
        const response = await api.patch("/rest-home/profile", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_user_profile");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnBtnRemoveClick() {
      try {
        this.loading = true;

        const params = { id: this.user_profile.id };
        const response = await api.delete("/rest-home/profile", { params });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_user_profile");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>